var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolEscapeRouteFieldObs = function SvgFiremapSymbolEscapeRouteFieldObs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#firemap-symbol-escape-route-field-obs_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.997,
    cy: 11.998,
    r: 10.279,
    fill: "#fff",
    transform: "rotate(90 11.997 11.998)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    fillRule: "evenodd",
    d: "M.005 11.998c0 6.623 5.37 11.992 11.992 11.992 6.623 0 11.992-5.37 11.992-11.992 0-6.623-5.37-11.992-11.992-11.992C5.374.006.005 5.376.005 11.998m1.999 0c0 5.519 4.474 9.993 9.993 9.993s9.993-4.474 9.993-9.993-4.474-9.993-9.993-9.993-9.993 4.474-9.993 9.993",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    d: "M11.113 9.724V7.85h-6.43v8.206h6.543v-1.873H7.017v-1.3h3.715v-1.873H7.017V9.724zM16.805 16.057h2.649l-1.594-2.681c.853-.503 1.324-1.393 1.324-2.61 0-1.862-1.212-2.915-3.322-2.915h-3.67v8.206h2.335v-2.213h1.235zm-2.278-4.086V9.724h1.336c.695 0 1.1.398 1.1 1.112 0 .737-.405 1.135-1.1 1.135z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "firemap-symbol-escape-route-field-obs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23.988v23.989H0z"
  })))));
};
export default SvgFiremapSymbolEscapeRouteFieldObs;